import React from 'react'
import AssetGroupsTree from '../AssetGroups/AssetGroupsTree'

const GroupFilter = ({setGroupFilter, setGroupName}) => {

  const handleClickGroupName = group => {
    setGroupName(group.displayName)
    setGroupFilter(prev => (group.id === prev ? '' : group.id))
  }

  return (
    <AssetGroupsTree onClick={handleClickGroupName} isClickable={() => true} />
  )
}

export default GroupFilter
